// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{ guestsWithContact: NonNullable<unknown> }} i
*/
export const messageBroadcast_guestsWithContact = (i) => `${i.guestsWithContact} Gäste haben Kontaktdaten angegeben.`